import { createRouter, createWebHistory } from 'vue-router';
import AccountDetailsPage from './components/account/account-details-page.vue';
import AccounTwoStepPage from './components/account/two-step-auth-page.vue';
import AmenitiesManagerPage from './components/policy/amenity-manager/amenities-manager.vue';
import AmenitiesMetaData from './components/policy/meta-data-manager/meta-data-manager.vue';
import AdminChannelErrors from './components/administrative/channel-errors/channel-errors.vue';
import AdminChannelErrorsNextPax from './components/administrative/channel-errors/nextpax-errors/nextpax-errors.vue';
import AdminChannelErrorsAirbnb from './components/administrative/channel-errors/airbnb-errors.vue';
import AdminChannelErrorsPaypal from './components/administrative/channel-errors/paypal-pending/paypal-pending.vue';
import AdminIssuerBilling from './components/administrative/issuer-billing/issuer-billing.vue';
import AdminChannelBilling from './components/administrative/channel-billing/channel-billing.vue';
import AdminIssuedPolicies from './components/administrative/issued-policies/issued-policies-page.vue';
import AdminRevenues from './components/reports/revenues.vue';
import AdminChannelCommissions from './components/administrative/channel-commissions/channel-commissions.vue';
import AdminChannelCommissionsNextPax from './components/administrative/channel-commissions/nextpax-commissions.vue';
import AdminChannelCommissionsAirbnb from './components/administrative/channel-commissions/airbnb-commissions.vue';
import AdminChannelCommissionsVrbo from './components/administrative/channel-commissions/vrbo-commissions.vue';
import AdminDamageClaimsList from './components/administrative/damage-claims/damage-claims-list.vue';
import GuestVerificationAttemptsReport from './components/reports/guest-verification-attempts-report/guest-verifications-attempts-report.vue';
import AdminGuestVerificationBillingReport from './components/administrative/guest-verification-billing/guest-verification-billing.vue';
import AdminManageGroups from './components/administrative/manage-groups/manage-groups.vue';
import AdminManageStaffGroups from './components/administrative/manage-groups/manage-staff-groups.vue';
import AdminImportHoliday from './components/administrative/holidays-imports/holidays-imports-page.vue';
import AdminSMSLogReport from './components/administrative/sms-log-report/sms-log-report.vue';
import AdminDeferredEmailsLogReport from './components/administrative/deferred-emails-report/deferred-emails-report.vue';
import AdminPushNotificationLogReport from './components/administrative/push-notification-log-report/push-notification-log-report.vue';
import AdminAppStatistics from './components/administrative/admin-app-statistics/admin-app-statistics.vue';
import StaylioAppStatistics from './components/administrative/staylio-app-statistics/staylio-app-statistics.vue';
import StaylioAppUsers from './components/administrative/staylio-app-statistics/staylio-app-users.vue';
import StaylioAppReservations from './components/administrative/staylio-app-statistics/staylio-app-reservations.vue';
import StaylioAppDownloads from './components/administrative/staylio-app-statistics/staylio-app-downloads.vue';
import StaylioAppConversion from './components/administrative/staylio-app-statistics/staylio-app-conversion.vue';
import StaylioAppPushNotifications from './components/administrative/staylio-app-statistics/staylio-app-push-notifications.vue';
import AiReport from './components/administrative/ai-report/ai-report.vue';
import AiReportMessage from './components/administrative/ai-report/ai-report-message.vue';
import AiReportUsage from './components/administrative/ai-report/ai-report-usage.vue';
import AdminSubscriberAccount from './components/administrative/subscriber-account/subscriber-account.vue';
import AdminSubscriberAccountDetails from './components/administrative/subscriber-account/details/subscriber-account-details.vue';
import AdminSubscriberSubscriptionHistory from './components/administrative/subscriber-account/history/subscriber-subscription-history.vue';
import AdminSubscriberPayments from './components/administrative/subscriber-account/payments/subscriber-payments.vue';
import AdminSubscriberSubscriptionDetails from './components/administrative/subscriber-account/subscription-details/subscriber-subscription-details.vue';
import AdminSubscriberUsers from './components/administrative/subscriber-account/users/subscriber-users.vue';
import AdminSubscriberBillingData from './components/administrative/subscriber-account/billing-data/subscriber-billing-data.vue';
import AdminSubscriberComments from './components/administrative/subscriber-account/comments/subscriber-account-comments.vue';
import AdminSubscriberCommunication from './components/administrative/subscriber-account/communication/subscriber-communication.vue';
import AdminSubscriberDamageProtection from './components/administrative/subscriber-account/damage-protection/subscriber-damage-protection.vue';
import AirbnbImport from './components/airbnb-import/airbnb-import.vue';
import ArrivalsReport from './components/reports/arrivals.vue';
import Comparative from './components/reports/comparative.vue';
import GeographicListing from './components/administrative/geographic-listing/geographic-listing-list.vue';
import SubscriberAirbnbList from './components/administrative/subscriber/airbnb-list/airbnb-list.vue';
import SubscriberUserList from './components/administrative/subscriber/user-list/user-list.vue';
import SubscriberRegistrationList from './components/administrative/subscriber/registration-list/registration-list.vue';
import SubscriberSubscriptionList from './components/administrative/subscriber/subscription-list/subscription-list.vue';
import SubscriberWordpressList from './components/administrative/subscriber/wordpress-list/wordpress-list.vue';
import Subscriber from './components/administrative/subscriber/subscriber.vue';
import SubscriptionPackages from './components/administrative/subscription-packages/subscription-packages-list.vue';
import CouponPackageList from './components/administrative/coupon-packages/coupon-package-list.vue';
import SystemEmailList from './components/administrative/system-email/system-email-list.vue';
import BackupHistory from './components/backup/history/backup-history.vue';
import BookingCalendarSettingsSingle from './components/booking-calendar/settings/booking-calendar-single.vue';
import BookingCalendarSettingsMulti from './components/booking-calendar/settings/booking-calendar-multi.vue';
import CalendarTapePreview from './components/calendar-tape/view/calendar-tape-preview.vue';
import CalendarTapePrevious from './components/calendar-tape/view/calendar-tape-previous.vue';
import CalendarTapeView from './components/calendar-tape/view/calendar-tape-view.vue';
import CalendarTapeConfigOptions from './components/calendar-tape/calendar-configuration-options/calendar-tape-config-options.vue';
import CalendarTapeColorAssignments from './components/calendar-tape/calendar-configuration-options/calendar-color-assignments.vue';
import CustomVariables from './components/custom-variables/custom-variables.vue';
import CustomPropertyVariables from './components/custom-variables/custom-property-variables.vue';
import CustomGlobalVariables from './components/custom-variables/custom-global-variables.vue';
import CustomInvoiceVariables from './components/custom-variables/custom-invoice-variables.vue';
import ChatHomePage from './components/chat/home.vue';
import ChatSettings from './components/chat/settings.vue';
import ChatSettingsSettings from './components/chat/settings/settings.vue';
import ChatPermissions from './components/chat/settings/permissions.vue';
import ChatOfficeHours from './components/chat/settings/office-hours.vue';
import DamageNotices from './components/reports/damage-notices/damage-notices.vue';
import DamageProtection from './components/damage-protection/damage-protection.vue';
import DamageProtectionClaimsEdit from './components/damage-protection/damage-protection-edit-claim/damage-protection-edit-claim.vue';
import DamageProtectionClaims from './components/damage-protection/damage-protection-claims/damage-protection-claims.vue';
import DamageProtectionIssuances from './components/damage-protection/damage-protection-issuances/damage-protection-issuances.vue';
import DamageProtectionSetup from './components/damage-protection/damage-protection-setup/damage-protection-setup.vue';
import Dashboard from './components/dashboard/dashboard.vue';
import DashboardList from './components/dashboard/list/dashboard-list.vue';
import DigitalSignatureList from './components/digital-signature/list/digital-signature-list.vue';
import DigitalSignatureSetup from './components/digital-signature/setup/digital-signature-setup.vue';
import DigitalSignaturePending from './components/digital-signature/pending/digital-signature-pending.vue';
import Document from './components/document/document.vue';
import DocumentEdit from './components/document/document-edit/document-edit.vue';
import DocumentAgreements from './components/document/document-agreements.vue';
import DocumentTemplates from './components/document/document-templates/document-templates.vue';
import DocumentUploads from './components/document/document-uploads/document-uploads.vue';
import DynamicPrisingBeyond from './components/dynamic-pricing/dynamic-pricing-beyond-list.vue';
import DynamicPrisingLabs from './components/dynamic-pricing/dynamic-pricing-labs-list.vue';
import DynamicPrisingLogs from './components/dynamic-pricing/dynamic-pricing-logs-list.vue';
import ERentalLockSettings from './components/door-lock/settings/e-rental-lock/e-rental-lock-settings.vue';
import KabaSettings from './components/door-lock/settings/kaba/kaba-settings.vue';
import PointCentralSettings from './components/door-lock/settings/point-central/point-central-settings.vue';
import RemoteLockSettings from './components/door-lock/settings/remote-lock/remote-lock-settings.vue';
import ResortLockSettings from './components/door-lock/settings/resort-lock/resort-lock-settings.vue';
import DoorLockSettings from './components/door-lock/settings/door-lock-settings.vue';
import PartnerVRBO from './components/partner/vrbo/vrbo.vue';
import PartnerNextpaxChannel from './components/partner/nextpax/nextpax-channel.vue';
import PartnerNextpax from './components/partner/nextpax/nextpax.vue';
import PartnerReviews from './components/partner/reviews/reviews.vue';
import PartnerAirbnb from './components/partner/airbnb/airbnb.vue';
import Partner from './components/partner/partner.vue';
import PaymentGateway from './components/payment-gateway/payment-gateway.vue';
import PaymentGatewayLogs from './components/payment-gateway/payment-gateway-logs/payment-gateway-logs.vue';
import PaymentGatewayOnlineOrder from './components/payment-gateway/payment-gateway-online-order/payment-gateway-online-order.vue';
import PaymentGatewayAutomatedPayments from './components/payment-gateway/payment-gateway-automated-payments/payment-gateway-automated-payments.vue';
import PaymentGatewaySetup from './components/payment-gateway/payment-gateway-setup/payment-gateway-setup.vue';
import PaymentGatewayPaymentTypes from './components/payment-gateway/payment-gateway-payment-types/payment-gateway-payment-types.vue';
import CreateDateBlock from './components/advanced-date-block/create-block.vue';
import EmbeddedPageSettings from './components/embedded-page/settings/embedded-page-settings.vue';
import WordpressPageSettings from './components/wordpress/settings/wordpress-page-settings.vue';
import Guest from './components/guest/guest.vue';
import GuestList from './components/guest/list/guest-list.vue';
import GuestCredit from './components/guest/credit/guest-credit.vue';
import GuestMerge from './components/guest/merge/guest-merge.vue';
import GuestEdit from './components/guest/edit/guest-edit.vue';
import GuestInvoices from './components/guest/invoices/guest-invoices.vue';
import GuestGeneratedQuotesReport from './components/reports/guest-generated-quotes.vue';
import GuestVerification from './components/guest-verification/guest-verification.vue';
import GuestVerificationSetup from './components/guest-verification/guest-verification-setup/guest-verification-setup.vue';
import GuestVerificationPending from './components/guest-verification/guest-verification-pending/guest-verification-pending.vue';
import GuestVerificationRequested from './components/guest-verification/guest-verification-requested/guest-verification-requested.vue';
import GuestVerificationLogs from './components/guest-verification/guest-verification-logs/guest-verification-logs.vue';
import GuestVerificationStatus from './components/guest-verification/guest-verification-status-page/guest-verification-status-page.vue';
import GuestVerificationTrustedGuests from './components/guest-verification/guest-verification-trusted-guests/guest-verification-trusted-guests.vue';
import GuestReviews from './components/guest/reviews/reviews.vue';

import HostedFormList from './components/hosted-form/hosted-form-list/hosted-form-list.vue';
import HostedFormPending from './components/hosted-form/hosted-form-pending.vue';
import HostedFormCompleted from './components/hosted-form/hosted-form-completed.vue';
import HostedFormBuilder from './components/hosted-form/hosted-form-builder-page.vue';
import HostedFormPage from './components/hosted-form/hosted-form-page.vue';

import SMSOptinPage from './components/sms-optin/sms-optin-page.vue';

import PropertyManager from './components/property-manager/property-manager.vue';
import ReservationDeposit from './components/property-manager/reservation-deposit.vue';
import SecurityDeposit from './components/property-manager/security-deposit.vue';
import Tax from './components/property-manager/tax.vue';
import Fee from './components/property-manager/fee.vue';
import Service from './components/property-manager/service.vue';
import Discount from './components/property-manager/discount.vue';
import Damage from './components/property-manager/damage.vue';

import Housekeeping from './components/reports/housekeeping/housekeeping.vue';
import IncomeDetail from './components/reports/income-detail/income-detail.vue';
import IncomeSummary from './components/reports/income-summary.vue';
import ICalendarLogs from './components/i-calendar/ical-logs-table.vue';
import ICalendarUrls from './components/i-calendar/ical-urls-table.vue';
import InvoiceChanges from './components/reports/invoice-changes.vue';
import InvoiceOperations_ from './components/reports/invoice-operations.vue';
import ISettings from './components/isettings/isettings.vue';
import ISettingGeneral from './components/isettings/isettings-general-page.vue';
import ISettingBookings from './components/isettings/isettings-bookings-page.vue';
import ISettingLocalization from './components/isettings/isettings-localization-page.vue';
import ISettingMarketing from './components/isettings/isettings-marketing-page.vue';
import PartnerCardList from './components/partner-card/list/partner-card-list.vue';
import PartnerAdminCategory from './components/partner-card/admin/partner-card-categories/partner-card-categories.vue';
import PartnerAdminData from './components/partner-card/admin/partner-card-data/partner-card-data.vue';
import PartnerAdminTooltips from './components/partner-card/admin/partner-card-tooltips/partner-card-tooltips.vue';
import LockoutConfig from './components/property/lockout/lockout-config-list.vue';
import OnlineBooking from './components/online-booking/online-booking.vue';
import OnlineBookingCalendar from './components/online-booking/calendar/online-booking-calendar.vue';
import OnlineBookingCheckout from './components/online-booking/checkout/online-booking-checkout.vue';
import OnlineBookingReservation from './components/online-booking/reservation/online-booking-reservation.vue';
import OnlineBookingQuoteForm from './components/online-booking/quote/online-booking-quote-form.vue';
import OnlineBookingQuoteSent from './components/online-booking/quote/online-booking-quote-sent.vue';
import OnlineBookingPaymentRequest from './components/online-booking/payment-request/online-booking-payment-request.vue';
import OnlineBookingPaymentRequestConfirmation from './components/online-booking/payment-request/online-booking-payment-request-confirmation.vue';
import OwnerStatement from './components/owner-statement/owner-statement.vue';
import OwnerStatementPreview from './components/owner-statement/owner-statement-preview.vue';
import OwnerStatementSummary from './components/owner-statement/owner-statement-summary.vue';
import OwnerStatementIRS1099 from './components/owner-statement/owner-statement-irs1099.vue';
import OwnerStatementLogs from './components/owner-statement/owner-statement-logs.vue';
import OwnerCreate from './components/owner/create/owner-create.vue';
import OwnerDocuments from './components/owner/documents/owner-documents.vue';
import OwnerEdit from './components/owner/edit/owner-edit.vue';
import OwnerList from './components/owner/list/owner-list.vue';
import OwnerListLogs from './components/owner/list/owner-list-logs.vue';
import TeamMemberList from './components/team-member/list/team-member-list.vue';
import TeamMemberCreate from './components/team-member/create/team-member-create.vue';
import TeamMemberEdit from './components/team-member/edit/team-member-edit.vue';
import PoliciesList from './components/policy/policy-list.vue';
import CancellationPoliciesList from './components/policy/cancellation-policy/cancellation-policy-list.vue';
import PropertyList from './components/property/list/property-list.vue';
import PropertyCategories from './components/property/categories/property-categories-list.vue';
import ResponsesList from './components/responses/responses-list.vue';
import ResponsesEdit from './components/responses/responses-edit.vue';
import ReferralReportPage from './components/reports/referral-report/referral-report-page.vue';
import RentalExpenseList from './components/rental-expense/rental-expense-list/rental-expense-list.vue';
import RecurringRentalExpenseList from './components/rental-expense/recurring-rental-expense-list/recurring-rental-expense-list.vue';
import ReportFeesServices from './components/reports/fees-services.vue';
import RentalPropertySetup from './components/property/setup/setup-property.vue';
import RentalPropertySetupDetails from './components/property/setup/details/details.vue';
import RentalPropertySetupAddress from './components/property/setup/address/address.vue';
import RentalPropertySetupRooms from './components/property/setup/rooms/rooms.vue';
import RentalPropertySetupAmenities from './components/property/setup/amenities/amenities.vue';
import RentalPropertySetupCustom from './components/property/setup/custom/custom.vue';
import RentalPropertySetupInfo from './components/property/setup/info/info.vue';
import RentalPropertySetupGallery from './components/property/setup/gallery/gallery.vue';
import RentalPropertySetupReviews from './components/property/setup/reviews/reviews.vue';
import RentalPropertySetupRoomTypes from './components/property/setup/roomtypes/roomtypes.vue';
import RentalPropertySetupRates from './components/property/setup/rates/rates.vue';
import RentalAgreementSignPage from './components/rental-agreement/rental-agreement-sign-page.vue';
import RentalAgreementAssignments from './components/digital-signature/assignments/rental-agreements-assignments.vue';
import Reservation from './components/reservation/reservation.vue';
import ReservationDetailsCreate from './components/reservation/details/reservation-details-create.vue';
import ReservationDetailsEdit from './components/reservation/details/reservation-details-edit.vue';
import ReservationInvoice from './components/reservation/invoice/reservation-invoice.vue';
import ReservationsPage from './components/reservations-list-page/reservations-page.vue';
import ReservationsList from './components/reservations-list-page/reservations-list/reservations-list.vue';
import ReservationsBlockedList from './components/reservations-list-page/blocked-reservations/blocked-reservations-list.vue';
import TravelInsurance from './components/travel-insurance/travel-insurance.vue';
import TravelInsuranceIssuances from './components/travel-insurance/issuances/travel-insurance-issuances.vue';
import TravelInsuranceSetup from './components/travel-insurance/setup/travel-insurance-setup.vue';
import TriggersLog from './components/reports/triggers-log/triggers-log.vue';
import TriggerList from './components/trigger/trigger-list.vue';
import TriggerEdit from './components/trigger/trigger-edit/trigger-edit.vue';
import WebsiteEditor from './components/website/website-editor/website-editor.vue';
import UnlayerTemplatesEdit from './components/website/unlayer-templates/unlayer-templates-edit.vue';
import WorkOrders from './components/work-orders/work-orders.vue';
import WorkOrdersList from './components/work-orders/work-orders-list/work-orders-list.vue';
import WorkOrdersVendorManager from './components/work-orders/work-orders-vendor-manager/work-orders-vendor-manager.vue';
import WorkOrdersExpenseAccounts from './components/work-orders/work-orders-configuration-options/work-orders-expense-accounts.vue';
import WorkOrdersJobTypes from './components/work-orders/work-orders-configuration-options/work-orders-job-types.vue';
import WorkOrdersVendorManagerForm from './components/work-orders/work-orders-vendor-manager/work-orders-vendor-manager-form.vue';
import WorkOrdersVendorManagerGrid from './components/work-orders/work-orders-vendor-manager/work-orders-vendor-manager-grid.vue';
import WorkOrdersManagerFormGrid from './components/work-orders/work-orders-vendor-manager/work-orders-manager-form-grid.vue';
import SeasonalityTemplate from './components/seasonality-template/seasonality-template.vue';
import SeasonalityTemplateProperties from './components/seasonality-template/properties/seasonality-template-properties.vue';
import SeasonalityTemplateSettings from './components/seasonality-template/settings/seasonality-template-settings.vue';
import SeasonalityTemplateTemplates from './components/seasonality-template/templates/seasonality-template-templates.vue';
import SubscriptionModules from './components/subscription-modules/subscription-modules-list.vue';
import PropertyMap from './components/property-map/property-map.vue';
import AdvanceDeposits from './components/reports/advance-deposits.vue';
import ReportCurrentGuests from './components/reports/current-guests/current-guests-page.vue';
import ReportDailyInquiries from './components/reports/daily-inquiries.vue';
import DiscountReport from './components/reports/discounts.vue';
import ReportIssuedPolicies from './components/reports/issued-policies.vue';
import ReportGuestTransactions from './components/reports/guest-transactions/guest-transactions.vue';
import ReportFailedTransactions from './components/reports/failed-transactions/failed-transactions.vue';
import ReportCancellation from './components/reports/cancellation.vue';
import ReportSettings from './components/reports/report-settings/report-settings-page.vue';
import GuestRegister from './components/reports/guest-register.vue';
import ReportLockoutAudit from './components/reports/lockout-audit.vue';
import DoorCodesLog from './components/reports/door-codes-log.vue';
import ReportSalesUseTax from './components/reports/tax.vue';
import ReceivablesReport from './components/reports/receivables.vue';
import DepartureReport from './components/reports/departure.vue';
import ChannelCommissionsReport from './components/reports/channel-commissions.vue';
import InquiryROIReport from './components/reports/inquiry-roi.vue';

import Quickbooks from './components/quickbooks/quickbooks.vue';
import QuickbooksSynchronize from './components/quickbooks/synchronize.vue';
import QuickbooksAccountMapping from './components/quickbooks/account-mapping.vue';
import QuickbooksAccountChart from './components/quickbooks/account-chart.vue';
import QuickbooksSyncFailLogs from './components/quickbooks/sync-fail-logs.vue';
import QuickbooksSynSuccesscLogs from './components/quickbooks/sync-success-logs.vue';
import QuickbooksErrorLogs from './components/quickbooks/error-logs.vue';
import QuickbooksClassMapping from './components/quickbooks/class-mapping.vue';
import QuickbooksSettings from './components/quickbooks/settings.vue';
import QuickbooksObjects from './components/quickbooks/objects.vue';

import QuickbooksOld from './components/quickbooks_old/quickbooks.vue';
import QuickbooksSynchronizeOld from './components/quickbooks_old/synchronize.vue';
import QuickbooksAccountMappingOld from './components/quickbooks_old/account-mapping.vue';
import QuickbooksAccountChartOld from './components/quickbooks_old/account-chart.vue';
import QuickbooksSyncFailLogsOld from './components/quickbooks_old/sync-fail-logs.vue';
import QuickbooksSynSuccesscLogsOld from './components/quickbooks_old/sync-success-logs.vue';
import QuickbooksErrorLogsOld from './components/quickbooks_old/error-logs.vue';
import QuickbooksClassMappingOld from './components/quickbooks_old/class-mapping.vue';

import RentalExpensesReport from './components/reports/rental-expenses.vue';
import DataDumpReport from './components/reports/data-dump.vue';
import OwnerStatementReport from './components/reports/owner-statement/owner-statement.vue';
import SalesDetailReport from './components/reports/sales-detail.vue';
import SalespersonDetailReport from './components/reports/salesperson-detail.vue';
import EmailMarketingSetup from './components/emarketing/setup.vue';
import SMSGatewaySetup from './components/sms_gateway/gateway.vue';
import SMSNumbersSetup from './components/sms_gateway/numbers.vue';
import SMSLogs from './components/sms_gateway/logs.vue';
import SMSSendMessage from './components/sms_gateway/send-message.vue';
import SubscriptionBillingPage from './components/subscription/billing/subscription-billing-page.vue';
import SubscriptionActivityPage from './components/subscription/activity/subscription-activity-page.vue';
import SubscriptionChangePage from './components/subscription/change/subscription-change-page.vue';
import SubscriptionSelectPage from './components/subscription/select/subscription-select-page.vue';
import SubscriptionCompletedPage from './components/subscription/completed/subscription-completed-page.vue';
import NotificationPage from './components/notification/notification-page.vue';
import DeviceList from './components/notification/devices-list.vue';
import VisualRatesTape from './components/visual-rates-tape/visual-rates-tape.vue';
import { getNextpaxChannels, NEXTPAX_CHANNEL_MAPPING } from './constants';

import StaylioApp from './components/staylio-app/staylio-app.vue';
import StaylioAppSettings from './components/staylio-app/staylio-app-settings.vue';
import MassPushNotification from './components/staylio-app/mass-push-notification/mass-push-notification.vue';
import MassPushNotificationList from './components/staylio-app/mass-push-notification/mass-push-notification-list.vue';
import MassPushNotificationCreate from './components/staylio-app/mass-push-notification/mass-push-notification-create.vue';
import MassPushNotificationDetail from './components/staylio-app/mass-push-notification/mass-push-notification-detail.vue';
import AiScanDashboard from './components/ai-scan-dashboard/ai-scan-dashboard.vue';

const routes = [
    {
        path: '/app/channel-commissions/admin',
        name: 'Channel Commissions',
        component: AdminChannelCommissions,
        children: [
            {
                path: 'nextpax/commissions',
                name: 'NextPax Commissions',
                component: AdminChannelCommissionsNextPax,
            },
            {
                path: 'airbnb/commissions',
                name: 'Airbnb Commissions',
                component: AdminChannelCommissionsAirbnb,
            },
            {
                path: 'vrbo/commissions',
                name: 'Vrbo Commissions',
                component: AdminChannelCommissionsVrbo,
            },
        ],
    },
    {
        path: '/app/administration-channel-errors',
        name: 'Channel Errors',
        component: AdminChannelErrors,
        children: [
            {
                path: 'nextpax/errors',
                name: 'NextPax Errors',
                component: AdminChannelErrorsNextPax,
            },
            {
                path: 'airbnb/errors',
                name: 'Airbnb Errors',
                component: AdminChannelErrorsAirbnb,
            },
            {
                path: 'paypal/errors',
                name: 'Paypal Errors',
                component: AdminChannelErrorsPaypal,
            },
        ],
    },
    {
        path: '/app/admin/user',
        name: 'User',
        component: AdminSubscriberAccount,
        children: [
            {
                path: 'details/:id',
                name: 'User Details',
                component: AdminSubscriberAccountDetails,
            },
            {
                path: 'subscription-details/:id',
                name: 'User Subscription Details',
                component: AdminSubscriberSubscriptionDetails,
            },
            {
                path: 'subscription-history/:id',
                name: 'User Subscription History',
                component: AdminSubscriberSubscriptionHistory,
            },
            {
                path: 'payments/:id',
                name: 'User Payments',
                component: AdminSubscriberPayments,
            },
            {
                path: 'users/:id',
                name: 'User Users',
                component: AdminSubscriberUsers,
            },
            {
                path: 'billing-data/:id',
                name: 'User Billing Data',
                component: AdminSubscriberBillingData,
            },
            {
                path: 'comments/:id',
                name: 'User Damage Comments',
                component: AdminSubscriberComments,
            },
            {
                path: 'damage-protection/:id',
                name: 'User Damage Protection',
                component: AdminSubscriberDamageProtection,
            },
            {
                path: 'communication/:id',
                name: 'User Communications',
                component: AdminSubscriberCommunication,
            },
        ],
    },
    { path: '/app/admin/sms-log-report/', component: AdminSMSLogReport },
    { path: '/app/admin/deferred-emails-report/', component: AdminDeferredEmailsLogReport },
    { path: '/app/admin/push-notification-log-report/', component: AdminPushNotificationLogReport },
    { path: '/app/admin/admin-app-statistics/', component: AdminAppStatistics },
    {
        path: '/app/admin/staylio-app-statistics',
        name: 'Staylio Guest App',
        component: StaylioAppStatistics,
        children: [
            {
                path: 'users',
                name: 'Staylio App Users',
                component: StaylioAppUsers,
            },
            {
                path: 'reservations',
                name: 'Staylio App Reservations',
                component: StaylioAppReservations,
            },
            {
                path: 'downloads',
                name: 'Staylio App Downloads',
                component: StaylioAppDownloads,
            },
            {
                path: 'push-notifications',
                name: 'Staylio App Push Notifications',
                component: StaylioAppPushNotifications,
            },
            {
                path: 'conversion',
                name: 'Staylio App Conversion',
                component: StaylioAppConversion,
            },
        ],
    },
    {
        path: '/app/admin/ai-report',
        component: AiReport,
        children: [
            {
                path: 'message',
                component: AiReportMessage,
            },
            {
                path: 'usage',
                component: AiReportUsage,
            }
        ]
    },
    { path: '/app/admin/damage-claims/', component: AdminDamageClaimsList },
    { path: '/app/admin/coupon-packages/', component: CouponPackageList },
    { path: '/app/admin/system-email/', component: SystemEmailList },
    { path: '/app/issued-policies/list/', component: AdminIssuedPolicies },
    { path: '/app/account/details', name: 'Account Profile', component: AccountDetailsPage },
    { path: '/app/account/two-step', name: 'Two Step Authentication', component: AccounTwoStepPage },
    { path: '/app/admin/issuer-billing', component: AdminIssuerBilling },
    { path: '/app/admin/channel-billing', component: AdminChannelBilling },
    { path: '/app/admin/manage-groups/', component: AdminManageGroups },
    { path: '/app/admin/manage-groups/staff/', component: AdminManageStaffGroups },
    { path: '/app/admin/holiday-import/', component: AdminImportHoliday },
    { path: '/app/admin/verification-billing-report/', component: AdminGuestVerificationBillingReport },
    { path: '/app/airbnb-import/', component: AirbnbImport },
    { path: '/app/airbnb-import/:error/', component: AirbnbImport },

    { path: '/app/backup/history', component: BackupHistory },
    {
        path: '/app/booking-calendar/settings/single',
        name: 'Single Calendar Settings',
        component: BookingCalendarSettingsSingle,
    },
    {
        path: '/app/booking-calendar/settings/multi',
        name: 'Multi Calendar Settings',
        component: BookingCalendarSettingsMulti,
    },
    { path: '/app/calendar-tape/preview', component: CalendarTapePreview },
    { path: '/app/calendar-tape/previous', component: CalendarTapePrevious },
    { path: '/app/calendar-tape/view', component: CalendarTapeView },
    { path: '/app/calendar-tape/options', component: CalendarTapeConfigOptions },
    { path: '/app/calendar-tape/assignments', component: CalendarTapeColorAssignments },
    { path: '/app/pricing/beyond/', name: 'Dynamic Pricing Beyond', component: DynamicPrisingBeyond },
    { path: '/app/pricing/labs/', name: 'Dynamic Pricing Labs', component: DynamicPrisingLabs },
    { path: '/app/pricing/logs/', name: 'Dynamic Pricing Logs', component: DynamicPrisingLogs },
    {
        path: '/app/custom-variable',
        name: 'Custom Variables',
        component: CustomVariables,
        children: [
            {
                path: 'global-variables',
                name: 'Global Variables',
                component: CustomGlobalVariables,
            },
            {
                path: 'property-variables',
                name: 'Property Variables',
                component: CustomPropertyVariables,
            },
            {
                path: 'invoice-variables',
                name: 'Invoice Variables',
                component: CustomInvoiceVariables,
            },
        ],
    },
    { path: '/app/dashboard', component: Dashboard },
    { path: '/app/dashboard/list', component: DashboardList },
    { path: '/app/digital-signature/list', name: 'Requested Digital Signatures', component: DigitalSignatureList },
    { path: '/app/digital-signature/setup', name: 'Setup Digital Signatures', component: DigitalSignatureSetup },
    { path: '/app/digital-signature/pending', name: 'Pending Digital Signatures', component: DigitalSignaturePending },
    { path: '/app/digital-signature/assignments', name: ' Assignments', component: RentalAgreementAssignments },

    {
        path: '/digital-signature/sign/:id',
        component: RentalAgreementSignPage,
    },
    {
        path: '/digital-signature/sign-ga/:id',
        component: RentalAgreementSignPage,
    },
    {
        path: '/app/damage-protection',
        name: 'Damage Protection Plans',
        component: DamageProtection,
        children: [
            {
                path: 'claims',
                name: 'Damage Protection - Claims',
                component: DamageProtectionClaims,
            },
            {
                path: 'issuances',
                name: 'Damage Protection - Issuances',
                component: DamageProtectionIssuances,
            },
            {
                path: 'setup',
                name: 'Damage Protection - Setup',
                component: DamageProtectionSetup,
            },
        ],
    },
    {
        path: '/app/damage-protection/claim/edit/:id',
        component: DamageProtectionClaimsEdit,
    },
    {
        path: '/app/document',
        name: 'Documents',
        component: Document,
        children: [
            {
                path: 'agreements',
                name: 'Rental Agreements Setup',
                component: DocumentAgreements,
            },
            {
                path: 'templates',
                name: 'Document Templates',
                component: DocumentTemplates,
            },
        ],
    },
    {
        path: '/app/document/uploads',
        name: 'File Uploads',
        component: DocumentUploads,
    },
    {
        path: '/app/document/:id/edit/',
        component: DocumentEdit,
    },
    {
        path: '/app/door-lock/settings',
        name: 'Door Locks',
        component: DoorLockSettings,
        children: [
            {
                path: 'e-rental-lock',
                name: 'Door Locks - eRental Lock',
                component: ERentalLockSettings,
            },
            {
                path: 'kaba',
                name: 'Door Locks - Kaba',
                component: KabaSettings,
            },
            {
                path: 'point-central',
                name: 'Door Locks - Point Central',
                component: PointCentralSettings,
            },
            {
                path: 'remote-lock',
                name: 'Door Locks - Remote Lock',
                component: RemoteLockSettings,
            },
            {
                path: 'resort-lock',
                name: 'Door Locks - Resort Lock',
                component: ResortLockSettings,
            },
        ],
    },
    {
        path: '/app/guest-verification',
        name: 'Guest Verify',
        component: GuestVerification,
        children: [
            {
                path: 'setup',
                name: 'Guest Verification - Setup',
                component: GuestVerificationSetup,
            },
            {
                path: 'requested',
                name: 'Guest Verification - Requested',
                component: GuestVerificationRequested,
            },
            {
                path: 'pending',
                name: 'Guest Verification - Pending',
                component: GuestVerificationPending,
            },
            {
                path: 'trusted-guests',
                name: 'Guest Verification - Trusted Guests',
                component: GuestVerificationTrustedGuests,
            },
            {
                path: 'logs',
                name: 'Guest Verification - Logs',
                component: GuestVerificationLogs,
            },
        ],
    },
    {
        path: '/sms/optin/:id/',
        name: 'SMS Opt-in',
        component: SMSOptinPage,
    },    
    {
        path: '/app/hosted-form/list/',
        name: 'Hosted Forms - List',
        component: HostedFormList,
    },
    {
        path: '/app/hosted-form/completed/',
        name: 'Hosted Forms - Completed',
        component: HostedFormCompleted,
    },
    {
        path: '/app/hosted-form/:id/edit/',
        name: 'Hosted Forms - Edit',
        component: HostedFormBuilder,
    },
    {
        path: '/app/hosted-form/pending/',
        name: 'Hosted Forms - Pending',
        component: HostedFormPending,
    },
    {
        path: '/hosted-form/:id/',
        name: 'Hosted Form',
        component: HostedFormPage,
    },
    {
        path: '/hosted-form/results/:id/',
        name: 'Hosted Forms - Results',
        component: HostedFormPage,
    },
    {
        path: '/guest-verification/success/',
        name: 'Guest Verifications - Success',
        component: GuestVerificationStatus,
    },
    {
        path: '/guest-verification/reject/',
        name: 'Guest Verifications - Reject',
        component: GuestVerificationStatus,
    },
    {
        path: '/app/partner',
        name: 'Integrations',
        component: Partner,
        children: [
            {
                path: 'vrbo',
                name: 'Integrations Vrbo',
                component: PartnerVRBO,
            },
            {
                path: 'nextpax',
                name: 'Integrations NextPax',
                component: PartnerNextpax,
                children: getNextpaxChannels().map((nextpaxChannel) => ({
                    path: nextpaxChannel.toLowerCase(),
                    name: `Integrations ${NEXTPAX_CHANNEL_MAPPING[nextpaxChannel]}`,
                    component: PartnerNextpaxChannel,
                })),
            },
            {
                path: 'airbnb',
                name: 'Integrations Airbnb',
                component: PartnerAirbnb,
            },
            {
                path: 'reviews',
                name: 'Integrations Reviews',
                component: PartnerReviews,
            },
        ],
    },
    {
        path: '/app/guest',
        name: 'Guests',
        component: Guest,
        children: [
            {
                path: 'list',
                name: 'Guest List',
                component: GuestList,
            },
            {
                path: 'new',
                name: 'Create Guest',
                component: GuestEdit,
            },
            {
                path: ':id/edit',
                name: 'Edit Guest',
                component: GuestEdit,
            },
            {
                path: ':id/invoices',
                name: 'Guest Control Panel',
                component: GuestInvoices,
            },
        ],
    },
    { path: '/app/embedded-page/settings', name: 'Inline Frame', component: EmbeddedPageSettings },
    { path: '/app/advanced-date-block/block', component: CreateDateBlock },
    { path: '/app/geographic/admin/list/', component: GeographicListing },
    { path: '/app/guest/credit', component: GuestCredit },
    { path: '/app/guest/merge', component: GuestMerge },
    { path: '/app/guest/reviews', component: GuestReviews },

    { path: '/app/emarketing/setup', component: EmailMarketingSetup },
    { path: '/app/sms/gateway/', name: 'SMS Gateway Setup', component: SMSGatewaySetup },
    { path: '/app/sms/numbers/', name: 'Phone Numbers', component: SMSNumbersSetup },
    { path: '/app/sms/logs/', name: 'SMS Logs', component: SMSLogs },
    { path: '/app/sms/send-message/', name: 'SMS Messaging', component: SMSSendMessage },
    { path: '/app/property/lockout', component: LockoutConfig },
    { path: '/app/partner-cards/list', name: 'Partner Cards', component: PartnerCardList },
    { path: '/app/partner-cards/admin', name: 'Partner Cards - Categories', component: PartnerAdminCategory },
    { path: '/app/partner-cards/admin/card-data', name: 'Partner Cards - List', component: PartnerAdminData },
    {
        path: '/app/partner-cards/admin/card-tooltips',
        name: 'Partner Card Tooltips',
        component: PartnerAdminTooltips,
    },
    {
        path: '/app/payment-gateway',
        name: 'Payment Gateway',
        component: PaymentGateway,
        children: [
            {
                path: 'logs',
                name: 'Payment Gateway Logs',
                component: PaymentGatewayLogs,
            },
            {
                path: 'payment-order',
                name: 'Payment Gateway Payment Order',
                component: PaymentGatewayOnlineOrder,
            },
            {
                path: 'automated-payments',
                name: 'Payment Gateway Automated Payments',
                component: PaymentGatewayAutomatedPayments,
            },
            {
                path: 'setup',
                name: 'Payment Gateway Setup',
                component: PaymentGatewaySetup,
            },
            {
                path: 'payment-types',
                name: 'Payment Gateway Types',
                component: PaymentGatewayPaymentTypes,
            },
        ],
    },
    {
        path: '/app/property-manager',
        name: 'Property Manager',
        component: PropertyManager,
        children: [
            {
                path: 'reservation-deposit',
                name: 'Reservation Deposit',
                component: ReservationDeposit,
            },
            {
                path: 'security-deposit',
                name: 'Security Deposit',
                component: SecurityDeposit,
            },
            {
                path: 'tax',
                name: 'Taxes',
                component: Tax,
            },
            {
                path: 'fee',
                name: 'Fees',
                component: Fee,
            },
            {
                path: 'service',
                name: 'Services',
                component: Service,
            },
            {
                path: 'discount',
                name: 'Discounts and Promo Codes',
                component: Discount,
            },
            {
                path: 'damage',
                name: 'Damage Protection',
                component: Damage,
            },
        ],
    },
    { path: '/app/property/admin/map/', component: PropertyMap },
    { path: '/app/owner-statement/list', name: 'Owner Statements', component: OwnerStatement },
    { path: '/app/owner-statement/list/:id/preview', name: 'Owner Statement', component: OwnerStatementPreview },
    { path: '/app/owner-statement/list/summary', name: 'Owner Statement Summary', component: OwnerStatementSummary },
    { path: '/app/owner-statement/list/irs1099', name: 'Owner Statement IRS 1099', component: OwnerStatementIRS1099 },
    { path: '/app/owner-statement/list/logs', name: 'Owner Statement Logs', component: OwnerStatementLogs },
    { path: '/app/owner/create', name: 'Add Owner', component: OwnerCreate },
    { path: '/app/owner/list', name: 'Property Management', component: OwnerList },
    { path: '/app/owner/list/logs', name: 'Owner Logs', component: OwnerListLogs },
    { path: '/app/owner/:id/documents', name: 'Owner Documents', component: OwnerDocuments },
    { path: '/app/owner/:id/edit', name: 'Owner Edit', component: OwnerEdit },
    { path: '/app/owner/:id/edit/access', name: 'Owner Edit Access', component: OwnerEdit },
    { path: '/app/owner/:id/edit/communication', name: 'Owner Edit Communication', component: OwnerEdit },
    { path: '/app/owner/:id/edit/documents', name: 'Owner Edit Documents', component: OwnerEdit },
    { path: '/app/owner/:id/edit/properties', name: 'Owner Edit Properties', component: OwnerEdit },
    { path: '/app/owner/:id/edit/taxes', name: 'Owner Edit Taxes', component: OwnerEdit },
    { path: '/app/team-member/list', name: 'Team Members', component: TeamMemberList },
    { path: '/app/team-member/create', name: 'Create Team Member', component: TeamMemberCreate },
    { path: '/app/team-member/:id/edit', name: 'Edit Team Member', component: TeamMemberEdit },
    { path: '/app/team-member/:id/edit/access', name: 'Edit Team Member Access', component: TeamMemberEdit },
    { path: '/app/team-member/:id/edit/communication', name: 'Team Member Communication', component: TeamMemberEdit },
    { path: '/app/team-member/:id/edit/properties', name: 'Edit Team Member Properties', component: TeamMemberEdit },
    { path: '/app/team-member/:id/edit/log', name: 'Team Member Log', component: TeamMemberEdit },
    {
        path: '/app/reservation',
        name: 'Reservation',
        component: Reservation,
        children: [
            {
                path: 'create',
                name: 'Create Reservation',
                component: ReservationDetailsCreate,
            },
            {
                path: 'edit/details/:id/:alterationId?',
                name: 'Reservation Details',
                component: ReservationDetailsEdit,
            },
            {
                path: 'edit/invoice/:id',
                name: 'Reservation Invoice',
                component: ReservationInvoice,
            },
        ],
    },
    {
        path: '/app/property/setup',
        name: 'Setup Rental Property',
        component: RentalPropertySetup,
        children: [
            {
                path: 'details/:id',
                name: 'Setup Rental Property - Details',
                component: RentalPropertySetupDetails,
            },
            {
                path: 'address/:id',
                name: 'Setup Rental Property - Address',
                component: RentalPropertySetupAddress,
            },
            {
                path: 'rooms/:id',
                name: 'Setup Rental Property - Rooms',
                component: RentalPropertySetupRooms,
            },
            {
                path: 'amenities/:id',
                name: 'Setup Rental Property - Amenities',
                component: RentalPropertySetupAmenities,
            },
            {
                path: 'rates/:id',
                name: 'Setup Rental Property - Rates',
                component: RentalPropertySetupRates,
            },
            {
                path: 'additional/:id',
                name: 'Setup Rental Property - Additional',
                component: RentalPropertySetupInfo,
            },
            {
                path: 'gallery/:id',
                name: 'Setup Rental Property - Gallery',
                component: RentalPropertySetupGallery,
            },
            {
                path: 'reviews/:id',
                name: 'Setup Rental Property - Reviews',
                component: RentalPropertySetupReviews,
            },
            {
                path: 'custom/:id',
                name: 'Setup Rental Property - Custom',
                component: RentalPropertySetupCustom,
            },
            {
                path: 'roomtypes/:id',
                name: 'Setup Rental Property - Roomtypes',
                component: RentalPropertySetupRoomTypes,
            },
        ],
    },
    { path: '/app/property/list', component: PropertyList },
    { path: '/app/policy/list/', name: 'Policies', component: PoliciesList },
    {
        path: '/app/policy/cancellation-policy/list/',
        name: 'Cancellation Policies',
        component: CancellationPoliciesList,
    },
    { path: '/app/policy/amenity-manager/list/', name: 'Amenities', component: AmenitiesManagerPage },
    { path: '/app/policy/meta-data/list/', name: 'Amenity Metadata', component: AmenitiesMetaData },
    { path: '/app/property/categories', component: PropertyCategories },
    { path: '/app/rental-expense/list', name: 'Rental Expenses - One-Time', component: RentalExpenseList },
    {
        path: '/app/rental-expense/recurring/list',
        name: 'Rental Expenses - Recurring',
        component: RecurringRentalExpenseList,
    },
    { path: '/app/reports/arrivals', component: ArrivalsReport },
    { path: '/app/reports/comparative', component: Comparative },
    { path: '/app/reports/fees-services', component: ReportFeesServices },
    { path: '/app/reports/referral/report/', component: ReferralReportPage },
    { path: '/app/reports/verification-attempts-report/', component: GuestVerificationAttemptsReport },
    { path: '/app/reports/advance-deposits', component: AdvanceDeposits },
    { path: '/app/reports/current-guests', component: ReportCurrentGuests },
    { path: '/app/reports/daily-inquiries', component: ReportDailyInquiries },
    { path: '/app/reports/damage-notices', component: DamageNotices },
    { path: '/app/reports/discounts/', component: DiscountReport },
    { path: '/app/reports/guest-generated-quotes/', component: GuestGeneratedQuotesReport },
    { path: '/app/reports/housekeeping', component: Housekeeping },
    { path: '/app/reports/income-detail', component: IncomeDetail },
    { path: '/app/reports/income-summary', component: IncomeSummary },
    { path: '/app/reports/issued-policies', component: ReportIssuedPolicies },
    { path: '/app/reports/cancellation', component: ReportCancellation },
    { path: '/app/reports/revenues/', component: AdminRevenues },
    { path: '/app/reports/triggers-logs/', component: TriggersLog },
    { path: '/app/reports/guest-register/', component: GuestRegister },
    { path: '/app/reports/lockout-audit/', component: ReportLockoutAudit },
    { path: '/app/reports/guest-transactions/', component: ReportGuestTransactions },
    { path: '/app/reports/failed-transactions/', component: ReportFailedTransactions },
    { path: '/app/reports/door-codes-log/', component: DoorCodesLog },
    { path: '/app/reports/tax/', component: ReportSalesUseTax },
    { path: '/app/reports/receivables/', component: ReceivablesReport },
    { path: '/app/reports/departure/', component: DepartureReport },
    { path: '/app/reports/channel-commissions/', component: ChannelCommissionsReport },
    { path: '/app/reports/inquiry-roi/', component: InquiryROIReport },
    { path: '/app/reports/rental-expenses/', component: RentalExpensesReport },
    { path: '/app/reports/data-dump/', component: DataDumpReport },
    { path: '/app/reports/report-settings/', component: ReportSettings },
    { path: '/app/reports/sales-detail/', component: SalesDetailReport },
    { path: '/app/reports/salesperson-detail/', component: SalespersonDetailReport },
    { path: '/app/responses/list/', name: 'Email (Responses)', component: ResponsesList },
    { path: '/app/responses/edit/:id/', name: 'Edit Email (Response)', component: ResponsesEdit },
    { path: '/app/reports/owner-statement/', component: OwnerStatementReport },
    { path: '/app/module/admin/list/', component: SubscriptionModules },
    {
        path: '/app/travel-insurance',
        name: 'Travel Insurances',
        component: TravelInsurance,
        children: [
            {
                path: '',
                name: 'Travel Insurances - Setup',
                component: TravelInsuranceSetup,
            },
            {
                path: 'setup',
                name: 'Travel Insurances - Setup',
                component: TravelInsuranceSetup,
            },
            {
                path: 'issuances',
                name: 'Travel Insurances - Issuances',
                component: TravelInsuranceIssuances,
            },
        ],
    },
    { path: '/app/trigger/list', name: 'Triggers', component: TriggerList },
    { path: '/app/trigger/:id/edit', name: 'Trigger Edit', component: TriggerEdit },
    { path: '/app/wordpress/settings', name: 'Wordpress Settings', component: WordpressPageSettings },
    {
        path: '/app/icalendar/urls',
        name: 'Icalendar Setup',
        component: ICalendarUrls,
    },
    {
        path: '/app/icalendar/logs',
        name: 'Icalendar Logs',
        component: ICalendarLogs,
    },
    {
        path: '/app/reports/invoice-operations/report/',
        component: InvoiceOperations_,
    },
    {
        path: '/app/reports/invoice-changes/report',
        component: InvoiceChanges,
    },
    {
        path: '/app/isettings',
        name: 'Important Settings',
        component: ISettings,
        children: [
            {
                path: 'general',
                name: 'Important Settings - General',
                component: ISettingGeneral,
            },
            {
                path: 'bookings',
                name: 'Important Settings - Bookings',
                component: ISettingBookings,
            },
            {
                path: 'localization',
                name: 'Important Settings - Localization',
                component: ISettingLocalization,
            },
            {
                path: 'marketing',
                name: 'Important Settings - Marketing',
                component: ISettingMarketing,
            },
        ],
    },
    {
        path: '/app/reservations-list',
        name: 'Reservations',
        component: ReservationsPage,
        children: [
            {
                path: 'reservation',
                name: 'Reservations',
                component: ReservationsList,
            },
            {
                path: 'blocked-reservation',
                name: 'Blocked Periods',
                component: ReservationsBlockedList,
            },
        ],
    },
    {
        path: '/app/seasonality-template',
        name: 'Rates / Rules / Seasonality',
        component: SeasonalityTemplate,
        children: [
            {
                path: 'properties',
                name: 'Seasonality - Properties',
                component: SeasonalityTemplateProperties,
            },
            {
                path: 'settings',
                name: 'Seasonality - Settings',
                component: SeasonalityTemplateSettings,
            },
            {
                path: 'templates/:template?',
                name: 'Seasonality - Templates',
                component: SeasonalityTemplateTemplates,
            },
        ],
    },
    {
        path: '/app/subscriber/admin',
        component: Subscriber,
        children: [
            {
                path: 'airbnb',
                name: 'Airbnb Activation',
                component: SubscriberAirbnbList,
            },
            {
                path: 'users',
                name: 'Users',
                component: SubscriberUserList,
            },
            {
                path: 'registrations',
                name: 'Registrations',
                component: SubscriberRegistrationList,
            },
            {
                path: 'subscriptions',
                name: 'Subscriptions',
                component: SubscriberSubscriptionList,
            },
            {
                path: 'wordpress',
                name: 'Wordpress Installations',
                component: SubscriberWordpressList,
            },
        ],
    },
    {
        path: '/app/quickbooks-old',
        component: QuickbooksOld,
        children: [
            {
                path: 'synchronize',
                name: 'QuickBooks Old - Synchronize',
                component: QuickbooksSynchronizeOld,
            },
            {
                path: 'account-mapping',
                name: 'QuickBooks Old - Account Mapping',
                component: QuickbooksAccountMappingOld,
            },
            {
                path: 'account-chart',
                name: 'QuickBooks Old - Account Chart',
                component: QuickbooksAccountChartOld,
            },
            {
                path: 'sync-fail-logs',
                name: 'QuickBooks Old - Sync Fail Logs',
                component: QuickbooksSyncFailLogsOld,
            },
            {
                path: 'sync-success-logs',
                name: 'QuickBooks Old - Sync Success Logs',
                component: QuickbooksSynSuccesscLogsOld,
            },
            {
                path: 'error-logs',
                name: 'QuickBooks Old - Error Logs',
                component: QuickbooksErrorLogsOld,
            },
            {
                path: 'class-mapping',
                name: 'QuickBooks Old - Class Mapping',
                component: QuickbooksClassMappingOld,
            },
        ],
    },        
    {
        path: '/app/quickbooks',
        component: Quickbooks,
        children: [
            {
                path: 'synchronize',
                name: 'QuickBooks - Synchronize',
                component: QuickbooksSynchronize,
            },
            {
                path: 'account-mapping',
                name: 'QuickBooks - Account Mapping',
                component: QuickbooksAccountMapping,
            },
            {
                path: 'account-chart',
                name: 'QuickBooks - Account Chart',
                component: QuickbooksAccountChart,
            },
            {
                path: 'sync-fail-logs',
                name: 'QuickBooks - Sync Fail Logs',
                component: QuickbooksSyncFailLogs,
            },
            {
                path: 'sync-success-logs',
                name: 'QuickBooks - Sync Success Logs',
                component: QuickbooksSynSuccesscLogs,
            },
            {
                path: 'error-logs',
                name: 'QuickBooks - Error Logs',
                component: QuickbooksErrorLogs,
            },
            {
                path: 'class-mapping',
                name: 'QuickBooks - Class Mapping',
                component: QuickbooksClassMapping,
            },
            {
                path: 'objects',
                component: QuickbooksObjects,
            },
            {
                path: 'settings',
                name: 'QuickBooks - Settings',
                component: QuickbooksSettings,
            },            
        ],
    },
    { path: '/app/subscription-package/admin/list/', component: SubscriptionPackages },
    { path: '/app/visual-rates-tape', component: VisualRatesTape },
    { path: '/app/website/editor', component: WebsiteEditor },
    { path: '/app/saved-replies/:id', name: 'Communications', component: UnlayerTemplatesEdit },
    {
        path: '/app/work-orders',
        name: 'Work Orders',
        component: WorkOrders,
        children: [
            {
                path: 'list',
                name: 'Work Order - List',
                component: WorkOrdersList,
            },
            {
                path: 'vendor-manager',
                name: 'Work Order - Vendors',
                component: WorkOrdersVendorManager,
                children: [
                    {
                        path: 'grid',
                        name: 'Work Order - Vendors',
                        component: WorkOrdersVendorManagerGrid,
                    },
                    {
                        path: ':id/edit',
                        name: 'Work Order - Vendor Edit',
                        components: {
                            default: WorkOrdersVendorManagerForm,
                            vendors: WorkOrdersManagerFormGrid,
                        },
                    },
                    {
                        path: 'create',
                        name: 'Work Order - Vendor Create',
                        component: WorkOrdersVendorManagerForm,
                    },
                ],
            },
            {
                path: 'expense-accounts',
                name: 'Work Order - Expense Accounts',
                component: WorkOrdersExpenseAccounts,
            },
            {
                path: 'job-types',
                name: 'Work Order - Job Types',
                component: WorkOrdersJobTypes,
            },
        ],
    },
    { path: '/app/subscription/billing/', name: 'Billing', component: SubscriptionBillingPage },
    { path: '/app/subscription/activity/', name: 'Billing Activity', component: SubscriptionActivityPage },
    { path: '/app/subscription/change/', name: 'Billing Change', component: SubscriptionChangePage },
    { path: '/app/subscription/select/', name: 'Subscription Select', component: SubscriptionSelectPage },
    { path: '/app/subscription/completed/', name: 'Subscription Completed', component: SubscriptionCompletedPage },
    {
        path: '/:websiteUrl',
        component: OnlineBooking,
        children: [
            {
                path: '',
                name: 'online-booking-calendar',
                component: OnlineBookingCalendar,
            },
            {
                path: 'area/:areaId',
                component: OnlineBookingCalendar,
            },
            {
                path: 'checkout',
                name: 'online-booking-checkout',
                component: OnlineBookingCheckout,
            },
            {
                path: 'reservation/:reservationId',
                component: OnlineBookingReservation,
            },
            {
                path: 'payment-request/:requestUUID',
                component: OnlineBookingPaymentRequest,
            },
            {
                path: 'payment-request/:requestUUID/confirmation',
                name: 'online-booking-payment-request-confirmation',
                component: OnlineBookingPaymentRequestConfirmation,
            },
        ],
    },
    {
        path: '/:websiteUrl/online-quote',
        component: OnlineBooking,
        children: [
            {
                path: ':reservationId',
                name: 'online-booking-quote-form',
                component: OnlineBookingQuoteForm,
            },
            {
                path: ':reservationId/sent',
                name: 'online-booking-quote-sent',
                component: OnlineBookingQuoteSent,
            },
        ],
    },
    {
        path: '/:websiteUrl/quote',
        component: OnlineBooking,
        children: [
            {
                path: ':quoteId',
                component: OnlineBookingCheckout,
            },
        ],
    },
    { path: '/app/chat/home/:pathMatch(.*)*', component: ChatHomePage },
    {
        path: '/app/chat/settings/',
        component: ChatSettings,
        children: [
            {
                path: 'settings',
                name: 'Inbox Settings',
                component: ChatSettingsSettings,
            },
            {
                path: 'permissions',
                name: 'Inbox Permissions',
                component: ChatPermissions,
            },
            {
                path: 'office-hours',
                name: 'Inbox Office Hours',
                component: ChatOfficeHours,
            },
        ],
    },
    { path: '/app/chat/settings/', component: ChatSettings },
    { path: '/app/notification/', name: 'Notifications', component: NotificationPage },
    { path: '/app/notification/devices/', name: 'Notification Devices', component: DeviceList },

    {
        path: '/app/staylio-app',
        component: StaylioApp,
        children: [
            {
                path: 'settings',
                component: StaylioAppSettings,
            },
        ],
    },
    {
        path: '/app/staylio-app/mass-push-notification',
        component: MassPushNotification,
        children: [
            {
                path: 'list',
                name: 'Staylio Push Notifications - List',
                component: MassPushNotificationList,
            },
            {
                path: 'create',
                name: 'Staylio Push Notifications - Create',
                component: MassPushNotificationCreate,
            },
            {
                path: ':id',
                name: 'Staylio Push Notification',
                component: MassPushNotificationDetail,
            },
        ],
    },
    {
        path: '/app/ai-scan/',
        name: 'AI Scan Dashboard',
        component: AiScanDashboard,
    },
];

export default createRouter({
    history: createWebHistory(),
    routes,
});
